'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
cbStripLeadgeneratieController.$inject = ['ApiService', 'EventsService'];
var _module = angular.module('cb.strips.cb-strip-leadgeneratie-v1.cbStripLeadgeneratieController', []);

_module.controller('cbStripLeadgeneratieController', cbStripLeadgeneratieController);

exports.default = _module;


function cbStripLeadgeneratieController(ApiService, EventsService) {

    var vm = this;

    vm.getData = getData;

    activate();

    function activate() {
        ApiService.attach({
            'beleggen-lead': {
                'getState': cbApiGetState
            }
        });
        vm.toestemming1 = false;
    };

    function getData() {
        vm.isDone = true;
        var data = {
            naam: vm.name,
            emailadres: vm.email,
            toestemming1: vm.toestemming1
        };
        EventsService.triggerResult('beleggen-lead', data);
    };

    function cbApiGetState(callback) {
        if (typeof callback !== 'function') {
            throw new Error('Expected callback to be a function');
        }

        callback.apply(this, [data]);
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/strips/leadgeneratie-v1/leadgeneratie.controller.js
// module id = 952
// module chunks = 1